import { render, staticRenderFns } from "./RejectView.vue?vue&type=template&id=11626749&"
import script from "./RejectView.vue?vue&type=script&lang=js&"
export * from "./RejectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports